module.exports = __webpack_public_path__ + "static/media/training-review-manage.120e19d9.svg";